import { AuthErrorComponent } from './pages/auth-error/auth-error.component';
import { EmailNotVerifiedComponent } from './pages/auth-error/email-not-verified/email-not-verified.component';
import { Route } from '@angular/router';
import { LocaleGuard } from './guards/locale.guard';
import { AuthCallbackComponent } from './pages/auth-callback/auth-callback.component';

export const advancedAuthRoutes: Route[] = [
  {
    canActivate: [LocaleGuard],
    path: 'auth-error',
    component: AuthErrorComponent,
    children: [
      {
        path: 'email-not-verified',
        component: EmailNotVerifiedComponent,
      },
    ],
  },
  {
    canActivate: [LocaleGuard],
    path: 'auth-callback',
    component: AuthCallbackComponent,
  },
];